import React from "react";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PaymentIcon from "@mui/icons-material/Payment";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LineStyleIcon from "@mui/icons-material/LineStyle";
import { useLocation } from "react-router-dom";
import DashboardTwoToneIcon from "@mui/icons-material/DashboardTwoTone";
// import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import DescriptionIcon from "@mui/icons-material/Description";
import BusinessIcon from "@mui/icons-material/Business";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
// import PaymentsIcon from "@mui/icons-material/Payments";
import SettingsIcon from "@mui/icons-material/Settings";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useSelector } from "react-redux";
import ReceiptIcon from "@mui/icons-material/Receipt";

const allLinkArray = (hasPracticeAdmin, isOrciCare = false) => [
  {
    to: "/dashboard",
    logo: <DashboardOutlinedIcon className="navbar-icon" />,
    label: "Dashboard",
  },

  {
    to: "/claims-dashboard",
    logo: <DashboardTwoToneIcon className="navbar-icon" />,
    label: "Claims - Need Action",
  },
  ...(isOrciCare
    ? [
        {
          to: "/billing-Invoices",
          logo: <ReceiptIcon className="navbar-icon" />,
          label: "Billing Invoices",
        },
      ]
    : []),
  {
    to: "/tagged-claims",
    logo: <AlternateEmailIcon className="navbar-icon" />,
    label: "Tagged Claims",
  },
  {
    to: "/documents",
    logo: <DescriptionIcon className="navbar-icon" />,
    label: "Documents",
  },
  {
    to: "/encounter",
    logo: <DashboardIcon className="navbar-icon" />,
    label: "Encounter",
  },
  {
    to: "/era",
    logo: <LineStyleIcon className="navbar-icon" />,
    label: "ERA",
  },
  //   {
  //     to: "/speech",
  //     logo: <RecordVoiceOverIcon className="navbar-icon" />,
  //     label: "speech"
  // },
  {
    to: "/charge-entry-reports",
    logo: <AssignmentIcon className="navbar-icon" />,
    label: "Charge Entry Report",
  },
  {
    to: "/reports",
    logo: <AssessmentIcon className="navbar-icon" />,
    label: "Reports",
  },
  // {
  //    to: "/analytics",
  //    logo: <AssessmentIcon className="navbar-icon" />,
  //    label: "Analytics"
  //},
  {
    to: "/billing-batch-report",
    logo: <AssessmentOutlinedIcon className="navbar-icon" />,
    label: "Billing Batch Report",
  },
  {
    to: "/payment",
    logo: <PaymentIcon className="navbar-icon" />,
    label: "Payment",
  },
  // {
  //   to: "/post-payment",
  //   logo: <PaymentsIcon className="navbar-icon" />,
  //   label: "Post Payment",
  // },
  {
    to: "/payer",
    logo: <BusinessIcon className="navbar-icon" />,
    label: "Payer",
  },
  ...(hasPracticeAdmin
    ? [
        {
          to: "/practice-settings",
          logo: <SettingsIcon className="navbar-icon" />,
          label: "Practice Settings",
        },
      ]
    : []),
  {
    to: "/login",
    logo: <ExitToAppIcon className="navbar-icon" />,
    label: "Logout",
  },
];

const Navbar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const userData = useSelector((state) => state.auth.authData);
  const practiceDetails = useSelector(
    (state) => state.auth.authData?.practice_details,
  );
  const practiceList = useSelector((state) => state.auth?.authData?.practices);

  const selectedPracticeDetails = practiceList.find(
    (item) => item?.practice_id === practiceDetails?.practice_id,
  );

  const hasPracticeAdmin = userData.groups.some((group) =>
    group.GroupName.includes("PracticeAdmin"),
  );

  return (
    <nav className={`navbar ${collapsed ? "hide-navbar" : "show-navbar"}`}>
      <CloseIcon
        fontSize="large"
        className="close-icon"
        onClick={() => setCollapsed(true)}
      />
      <ul>
        {allLinkArray(
          hasPracticeAdmin,
          selectedPracticeDetails?.source_entity === "Orci Care",
        ).map((l) => (
          <li
            className={location.pathname === l.to ? "selected" : null}
            key={l.label}
          >
            <Link className="link" to={l.to} onClick={() => setCollapsed(true)}>
              <span className="img">{l.logo}</span>
              <span className="linkspan">{l.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
